import apiApp from '@/api/config/apiApp'

export function generateSolvencyCertificatePDF ({ pqrsId, year, month }) {
  return apiApp.post('/solvency-certificate/generate', {
    pqrsId,
    yearOfSolvency: year,
    monthOfSolvency: month
  })
}
